const styles = {
	detailsContainer: {
		width: '100% !important',
		margin: '0 !important',
	},
	actionContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	detailsPreCallContainer: {
		width: '100% !important',
		margin: '0 !important',
		paddingTop: '5px',
	},
	firstTabTopCard: {
		borderTopLeftRadius: '6px',
		borderTopRightRadius: '6px',
		borderBottomRightRadius: '0px',
		borderBottomLeftRadius: '0px',
		marginBottom: '0px',
	},
	firstTabBottomCard: {
		borderTopLeftRadius: '0px',
		borderTopRightRadius: '0px',
		borderBottomRightRadius: '6px',
		borderBottomLeftRadius: '6px',
		marginTop: '2px',
	},
	phantomFooter: {
		display: 'block',
		padding: '20px',
		height: '60px',
		width: '100%',
	},
	footer: {
		backgroundColor: "#F8F8F8",
		borderTop: "1px solid #E7E7E7",
		textAlign: "center",
		padding: "26px",
		position: "fixed",
		left: "0",
		bottom: "0",
		height: "91px",
		width: "100%",
		display: 'flex',
		justifyContent: 'flex-end',
	},
	preCallButtons: {
		marginTop: '0px',
		marginRight: '5px',
		marginBottom: '0px',
		marginLeft: '5px',
		width: '180px',
		height: '43px',
		fontSize: '12px',
	},
	buttonIcon: {
		marginRight: '9px',
	},
	customCallContainer: {
		display: 'flex',
	},
	customCallPurpose: {
		width: '90%',
	},
	customCallSaveWrapper: {
		height: '60px',
	},
	customCallSave: {
		paddingRight: '12px',
		paddingTop: '42px',
	},
	previewContainer: {
		margin: '0px -20px',
		backgroundColor: '#F5F5F5',
		width: 'calc(100% + 40px)',
	},
	subTitle: {
		margin: '30px 0 0',
		color: '#aaa',
	},
	dateTimeWrapper: {
		'& .rdtPicker': {
			top: '65px',
		},
	},
	loadingIndicator: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
};

export default styles;